// extracted by mini-css-extract-plugin
export default {"mainSlider":"Product_mainSlider__t3xgU","bigSlider":"Product_bigSlider__v5tUV"};